<template>
  <div class="switcher">
    <label class="switcher__label">Moving average (days)</label>
    <!-- note: coreui v3 CSwitch issue, v-model doesn't work -->

    <b-form-input class="avg-number" v-if="enabled"
                  min="0"
                  max="100"
                  type="number"
                  size="sm"
                  placeholder="Days"
                  v-model="days"
                  @input="daysChanged"/>

    <CSwitch :checked="enabled"
             @update:checked="handleChecked"
             v-bind="labelTxt"
             class="mx-1" color="dark" variant="outline" shape="pill" size="sm" />
  </div>
</template>

<script>
  export default {
    name: 'moving-average-switch',
    components: {},
    props: {
      value: {
        type: Number,
        default: null,
      },
    },
    data: function () {
      const defaultDays = 20;

      return {
        enabled: false,
        days: defaultDays,
        defaultDays: defaultDays,

        labelTxt: {
          labelOn: 'on',
          labelOff: 'off'
        },
      };
    },
    methods: {
      handleChecked(value) {
        // to emulate "v-model" behaviour
        this.enabled = value;

        if(value) {
          this.resetState();
          this.$emit('input', parseInt(this.days));
        } else {
          this.$emit('input', null);
        }
      },

      daysChanged(value) {
        if(parseInt(value)) {
          this.$emit('input', parseInt(value));
        } else {
          this.$emit('input', null);
        }
      },

      resetState() {
        this.days = this.defaultDays;
      },
    },
  }
</script>

<style scoped lang="scss">
  .switcher {
    display: flex;
    align-items: center;
    margin-left: 5px;

    &__label {
      margin: 0 5px 0 0;
    }

    input.form-control {
      width: 40px;
      height: 21px;
      padding: 0.1rem 0.3rem;
      margin: 0 0.2rem;
    }
  }
  .avg-number {
    min-width: 50px;
  }
</style>
